import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import RemoveIcon from '@material-ui/icons/Remove';
import { selectedReviewItemStyles } from '../../../../global/constants/theme/styles/components/selected-review-item';

interface Props {
    name?: string;
    relationshipLabel?: string;
    checked?: boolean;
}

export function ReviewCoverageItem(props: Props) {

    const selectedItemClasses = selectedReviewItemStyles();

    return (
        <div className={`divider-section-item ${selectedItemClasses.selectedReviewItem}`}>

            <div className='selected-review-item-inner' >
                <div className='selected-review-item-content'>
                    {props.checked ? <CheckIcon className='selected-review-item-icon added' /> : <RemoveIcon className='selected-review-item-icon removed' />}
                    <div>
                        {props.name && <p> <strong>{props.name}</strong></p>}
                        <p className='input-caption'>{props.relationshipLabel}</p>

                    </div>
                </div>
            </div>
        </div>
    );
}

ReviewCoverageItem.defaultProps = {
    name: null,
    relationshipLabel: null,
    checked: true,
};